module.exports = __webpack_public_path__ + "img/right.bc1a4e87.png";